import React, { useState } from "react";
import Icon from "../../../Elements/Icon/Icon.tsx";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useMailView } from "contexts/mailViewContext/mailViewContext.js";

const FolderDivider = ({ itemId, folderId, name }) => {
  const { getPathToFolder, getFoldersData, getSorting, getFolderStructured } =
    useMail();
  const { setFilesSelection, getFilesSelection } = useMailView();
  const [hover, setHover] = useState(false);
  const id = folderId || itemId.split("folder")[1];

  if (getSorting().by === "Extention" && getFolderStructured()) {
    return (
      <span className="folder-name">
        <div className={`icon-wrapper`}>
          <Icon name={"folders"} xl />
        </div>
        {id}
      </span>
    );
  }

  const fullPath = getPathToFolder(id);
  const folderFilesIds = getFoldersData()[id].filesIds.map(
    (fileId) => "" + fileId
  );

  const allFilesSelected = folderFilesIds.every((fileId) =>
    getFilesSelection().includes(fileId)
  );

  const someFilesSelected = folderFilesIds.some((fileId) =>
    getFilesSelection().includes(fileId)
  );

  const checkMarkCondition = hover || allFilesSelected || someFilesSelected;

  const handleSelectFolderFiles = () => {
    if (allFilesSelected) {
      setFilesSelection(
        getFilesSelection().filter(
          (fileId) => !folderFilesIds.includes("" + fileId)
        )
      );
    } else {
      if (folderFilesIds?.length) {
        const notSelected = folderFilesIds.filter(
          (fileId) => !getFilesSelection().includes("" + fileId)
        );
        setFilesSelection([...getFilesSelection(), ...notSelected]);
      }
    }
  };

  return (
    <span
      className="folder-name"
      key={checkMarkCondition}
      onMouseEnter={() => {
        if (folderFilesIds?.length) setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onClick={handleSelectFolderFiles}
    >
      <div
        className={`icon-wrapper
        ${allFilesSelected ? " all-selected" : ""}
        ${hover || someFilesSelected ? " hovered" : ""}`}
      >
        <Icon name={checkMarkCondition ? "check" : "folders"} xl />
      </div>
      {fullPath &&
        fullPath.map(({ name }, index) => (index > 0 ? " / " : "") + name)}
    </span>
  );
};

export default FolderDivider;
